export const webURL = 'https://admin.cms.luyenthitiendat.vn';
export const baseURL = 'https://api.luyenthitiendat.vn';
export const imgURL = 'https://media.luyenthitiendat.vn/';
